import { useEffect } from 'react'

export function usePageTitle(title = null) {
  useEffect(() => {
    document.title = title ? `${title} • ${process.env.REACT_APP_NAME}` : process.env.REACT_APP_NAME
  })
}
